import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import CookieConsent from './components/CookieConsent';
import './App.css';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import GrammarPage from './pages/GrammarPage';
import GrammarTopicPage from './pages/GrammarTopicPage';
import VocabularyPage from './pages/VocabularyPage';
import ReadingPage from './pages/ReadingPage';
import ReadingExercisePage from './pages/ReadingExercisePage';
import SubscriptionPage from './pages/SubscriptionPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import DisclaimerPage from './pages/DisclaimerPage';
import ConversationsPage from './pages/ConversationsPage';
import ContactPage from './pages/ContactPage';
import ReviewsPage from './pages/ReviewsPage';

// Career Path Pages
import HealthcareCareerPage from './pages/careers/HealthcareCareerPage';
import HospitalityCareerPage from './pages/careers/HospitalityCareerPage';
import BusinessCareerPage from './pages/careers/BusinessCareerPage';
import LogisticsCareerPage from './pages/careers/LogisticsCareerPage';
import ITCareerPage from './pages/careers/ITCareerPage';
import EngineeringCareerPage from './pages/careers/EngineeringCareerPage';

// Integration Pages
import HealthcareSystemPage from './pages/integration/HealthcareSystemPage';
import VisaInformationPage from './pages/integration/VisaInformationPage';
import FindingHousingPage from './pages/integration/FindingHousingPage';
import BusinessSetupPage from './pages/integration/BusinessSetupPage';
import DailyLifePage from './pages/integration/DailyLifePage';
import EducationPage from './pages/integration/EducationPage';
import FuhrerscheinPage from './pages/integration/FuhrerscheinPage';
import ScrollToTop from './components/ScrollToTop';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - SYNCHRONOUS CHECK
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/grammar" element={<GrammarPage />} />
      <Route path="/grammar/:topicId" element={<GrammarTopicPage />} />
      <Route path="/vocabulary" element={<VocabularyPage />} />
      <Route path="/reading" element={<ReadingPage />} />
      <Route path="/reading/:readingId" element={<ReadingExercisePage />} />
      <Route path="/subscription" element={<SubscriptionPage />} />
      <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="/datenschutz" element={<DatenschutzPage />} />
      <Route path="/disclaimer" element={<DisclaimerPage />} />
      <Route path="/convos" element={<ConversationsPage />} />
      <Route path="/conversations" element={<ConversationsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      
      {/* Career Path Routes */}
      <Route path="/careers/healthcare" element={<HealthcareCareerPage />} />
      <Route path="/careers/hospitality" element={<HospitalityCareerPage />} />
      <Route path="/careers/business" element={<BusinessCareerPage />} />
      <Route path="/careers/logistics" element={<LogisticsCareerPage />} />
      <Route path="/careers/it" element={<ITCareerPage />} />
      <Route path="/careers/engineering" element={<EngineeringCareerPage />} />
      
      {/* Integration Routes */}
      <Route path="/integration/healthcare-system" element={<HealthcareSystemPage />} />
      <Route path="/integration/visa" element={<VisaInformationPage />} />
      <Route path="/integration/housing" element={<FindingHousingPage />} />
      <Route path="/integration/business-setup" element={<BusinessSetupPage />} />
      <Route path="/integration/daily-life" element={<DailyLifePage />} />
      <Route path="/integration/education" element={<EducationPage />} />
      <Route path="/integration/fuhrerschein" element={<FuhrerscheinPage />} />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <CookieConsent />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
